/* 7ate9 linen pages: cart. Markup lives in sections/linen-bag-drawer.liquid.
   Linen.cart = { add(items, { openBag }), change(key, qty), refresh(), openBag(opener), closeBag(),
                  quickAdd(handle, opener), buyNow(variantId, qty, event), toast(message) }
   Hooks: [data-linen-open-bag], [data-linen-quick-add="<handle>"] (+ data-colour-name, data-title),
          [data-linen-add-variant="<variant id>"], [data-linen-cart-count].
   Event: linen:cart:updated { itemCount, offerCount } on document after every cart change.
   GoKwik owns the checkout button; nothing here touches it. */
(function () {
  var Linen = (window.Linen = window.Linen || {});
  if (Linen.cart) return;

  var SECTION = 'linen-bag-drawer';
  var products = {};
  var toastTimer;

  function config() {
    var el = document.getElementById('LinenCartConfig');
    try {
      return el ? JSON.parse(el.textContent) : {};
    } catch (e) {
      return {};
    }
  }

  function str(key, fallback) {
    return (config().strings || {})[key] || fallback;
  }

  function routes() {
    return Linen.routes || { root: '/', cartAdd: '/cart/add', cartChange: '/cart/change' };
  }

  function rootUrl() {
    var root = routes().root || '/';
    return root.slice(-1) === '/' ? root : root + '/';
  }

  function escapeHtml(text) {
    return String(text).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res
        .json()
        .catch(function () {
          return {};
        })
        .then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || str('error', 'Something went wrong. Please try again.'));
          return data;
        });
    });
  }

  function bagContent() {
    return document.querySelector('[data-linen-bag-content]');
  }

  function counts() {
    var content = bagContent();
    return {
      itemCount: content ? parseInt(content.getAttribute('data-item-count'), 10) || 0 : 0,
      offerCount: content ? parseInt(content.getAttribute('data-offer-count'), 10) || 0 : 0
    };
  }

  function sync() {
    var detail = counts();
    document.querySelectorAll('[data-linen-cart-count]').forEach(function (el) {
      el.textContent = detail.itemCount;
      el.hidden = detail.itemCount === 0;
    });
    document.dispatchEvent(new CustomEvent('linen:cart:updated', { detail: detail }));
  }

  // Swap the cart-dependent parts of the bag section; animate progress bars from their old width.
  var latestRequest = 0;

  function render(html, requestId) {
    if (!html) return;
    if (requestId && requestId < latestRequest) return; // a newer cart response already rendered
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var widths = {};
    document.querySelectorAll('[data-linen-progress]').forEach(function (el) {
      widths[el.getAttribute('data-linen-progress')] = el.style.width;
    });
    var active = document.activeElement;
    var focusKey = active && active.getAttribute && active.getAttribute('data-focus-key');
    var focusInBag = active && active.closest && active.closest('#LinenBag');
    var hadBar = !!document.querySelector('.linen-bagbar');

    ['[data-linen-bag-content]', '[data-linen-bag-bar]'].forEach(function (selector) {
      var fresh = doc.querySelector(selector);
      var current = document.querySelector(selector);
      if (fresh && current) current.replaceWith(fresh);
    });

    if (hadBar) {
      var bar = document.querySelector('.linen-bagbar');
      if (bar) bar.classList.add('is-static');
    }

    document.querySelectorAll('[data-linen-progress]').forEach(function (el) {
      var from = widths[el.getAttribute('data-linen-progress')];
      var to = el.style.width;
      if (!from || from === to) return;
      el.style.transition = 'none';
      el.style.width = from;
      void el.offsetWidth;
      el.style.transition = '';
      el.style.width = to;
    });

    if (focusInBag) {
      var target = (focusKey && document.querySelector('[data-focus-key="' + focusKey + '"]')) || document.querySelector('#LinenBag [data-linen-panel]');
      if (target) target.focus({ preventScroll: true });
    }
    sync();
  }

  function toast(message) {
    var el = document.querySelector('[data-linen-toast]');
    if (!el || !message) return;
    el.textContent = message;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      el.classList.remove('is-visible');
    }, 4000);
  }

  function getProduct(handle) {
    if (!products[handle]) {
      products[handle] = fetch(rootUrl() + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } }).then(function (res) {
        if (!res.ok) throw new Error(str('error', 'Something went wrong. Please try again.'));
        return res.json();
      });
      products[handle].catch(function () {
        delete products[handle];
      });
    }
    return products[handle];
  }

  function parseHints(raw) {
    var map = {};
    String(raw || '')
      .split(/\r?\n/)
      .forEach(function (line) {
        var i = line.indexOf(':');
        if (i > 0) map[line.slice(0, i).trim()] = line.slice(i + 1).trim();
      });
    return map;
  }

  function fillSheet(sheet, product, opener) {
    var cfg = config();
    var data = (opener && opener.dataset) || {};
    var isOffer = (cfg.offerHandles || []).indexOf(product.handle) > -1;
    var q = function (selector) {
      return sheet.querySelector(selector);
    };

    var img = q('[data-qa-img]');
    var src = product.featured_image;
    img.hidden = !src;
    if (src) img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=312';

    q('[data-qa-title]').textContent = data.title || data.colourName || product.title;
    q('[data-qa-sub]').textContent = data.title && data.colourName ? data.colourName : isOffer ? str('subtitle', '') : product.type || '';

    var shown =
      product.variants.filter(function (v) {
        return v.available;
      })[0] || product.variants[0];
    var compare = shown.compare_at_price && shown.compare_at_price > shown.price ? shown.compare_at_price : 0;
    q('[data-qa-price]').textContent = Linen.formatMoney(shown.price);
    q('[data-qa-compare]').textContent = compare ? Linen.formatMoney(compare) : '';
    q('[data-qa-off]').textContent = compare ? str('off', '[percent]% off').replace('[percent]', Math.floor(((compare - shown.price) * 100) / compare)) : '';

    var nudge = q('[data-qa-nudge]');
    var offerCount = counts().offerCount;
    var offerMin = cfg.offerMin || 2;
    nudge.hidden = !isOffer || !cfg.offerOn;
    nudge.textContent = offerCount >= offerMin ? str('nudge2', '') : offerCount > 0 ? str('nudge1', '') : str('nudge0', '');

    var sizeName = String(cfg.sizeOption || 'Size').toLowerCase();
    var index = 0;
    product.options.forEach(function (option, i) {
      if (String(option.name || option).toLowerCase() === sizeName) index = i;
    });
    var values = (product.options[index] && product.options[index].values) || [];
    var hints = parseHints(cfg.hints);
    var anyHint = false;
    q('[data-qa-sizes]').innerHTML = values
      .map(function (value) {
        var matches = product.variants.filter(function (v) {
          return v.options[index] === value;
        });
        var variant =
          matches.filter(function (v) {
            return v.available;
          })[0] || matches[0];
        if (!variant) return '';
        var hint = isOffer ? hints[value] || '' : '';
        if (hint) anyHint = true;
        var label = value + (hint ? ', ' + hint : '') + (variant.available ? '' : ', ' + str('soldOut', 'sold out'));
        return (
          '<button type="button" class="linen-size" data-qa-variant="' + variant.id + '"' +
          (variant.available ? '' : ' aria-disabled="true"') +
          ' aria-label="' + escapeHtml(label) + '">' +
          '<span class="linen-size__k">' + escapeHtml(value) + '</span>' +
          (hint ? '<span class="linen-size__n">' + escapeHtml(hint) + '</span>' : '') +
          '</button>'
        );
      })
      .join('');
    q('[data-qa-hint-label]').hidden = !anyHint;

    var error = q('[data-qa-error]');
    error.hidden = true;
    error.textContent = '';
  }

  function waitForGoKwik() {
    return new Promise(function (resolve) {
      if (typeof window.onBuyNowClick === 'function') return resolve();
      var poll, timeout;
      function done() {
        window.removeEventListener('gokwikLoaded', done);
        clearInterval(poll);
        clearTimeout(timeout);
        resolve();
      }
      window.addEventListener('gokwikLoaded', done);
      poll = setInterval(function () {
        if (typeof window.onBuyNowClick === 'function') done();
      }, 100);
      timeout = setTimeout(done, 3000);
    });
  }

  var cart = (Linen.cart = {
    add: function (items, options) {
      options = options || {};
      var requestId = ++latestRequest;
      var bag = document.getElementById('LinenBag');
      var optimistic = options.openBag !== false && bag;
      var wasOpen = bag && bag.classList.contains('is-open');
      // Open the bag right away (busy bar on top) instead of waiting ~0.7s for Shopify.
      if (optimistic) {
        bag.classList.add('is-busy');
        if (!wasOpen) cart.openBag();
      }
      return post(routes().cartAdd + '.js', {
        items: items,
        sections: SECTION,
        sections_url: location.pathname + location.search
      }).then(
        function (data) {
          render(data.sections && data.sections[SECTION], requestId);
          if (bag) bag.classList.remove('is-busy');
          return data;
        },
        function (err) {
          if (bag) bag.classList.remove('is-busy');
          if (optimistic && !wasOpen) cart.closeBag();
          throw err;
        }
      );
    },

    change: function (key, quantity) {
      var requestId = ++latestRequest;
      return post(routes().cartChange + '.js', {
        id: key,
        quantity: quantity,
        sections: SECTION,
        sections_url: location.pathname + location.search
      }).then(
        function (data) {
          render(data.sections && data.sections[SECTION], requestId);
          return data;
        },
        function (err) {
          // Shopify can still change the line on an error (e.g. capped to stock), so show the real cart.
          cart.refresh().catch(function () {});
          throw err;
        }
      );
    },

    refresh: function () {
      // No Accept: application/json header: on /products/* Shopify then answers with the product JSON, not the section.
      return fetch(location.pathname + '?sections=' + SECTION)
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          render(data[SECTION]);
        });
    },

    openBag: function (opener) {
      var bag = document.getElementById('LinenBag');
      if (!bag) return;
      Linen.openModal(bag, opener);
      // GoKwik rescans for checkout buttons on this event.
      document.dispatchEvent(new CustomEvent('cart:open'));
    },

    closeBag: function () {
      Linen.closeModal(document.getElementById('LinenBag'));
    },

    quickAdd: function (handle, opener) {
      var sheet = document.getElementById('LinenQuickAdd');
      if (!sheet || !handle) return Promise.resolve();
      if (opener) opener.classList.add('is-loading');
      return getProduct(handle)
        .then(function (product) {
          if (product.variants.length === 1) return cart.add([{ id: product.variants[0].id, quantity: 1 }]);
          fillSheet(sheet, product, opener);
          Linen.openModal(sheet, opener);
        })
        .catch(function (err) {
          toast(err.message);
        })
        .then(function () {
          if (opener) opener.classList.remove('is-loading');
        });
    },

    buyNow: function (variantId, quantity, event) {
      quantity = quantity || 1;
      return waitForGoKwik().then(function () {
        if (typeof window.onBuyNowClick === 'function') {
          try {
            window.onBuyNowClick(event || new MouseEvent('click'), false, [{ id: Number(variantId), quantity: quantity }]);
            return;
          } catch (err) {
            console.warn('[Linen] GoKwik buy now failed, using Shopify checkout', err);
          }
        }
        // Cart permalink: checks out just this item, not the rest of the bag.
        window.location.href = (Linen.routes.root || '/') + 'cart/' + Number(variantId) + ':' + quantity;
      });
    },

    toast: toast
  });

  // GoKwik closes cart drawers by calling close() on [data-cart-drawer].
  if (!customElements.get('linen-bag')) {
    customElements.define(
      'linen-bag',
      class extends HTMLElement {
        open(opener) {
          cart.openBag(opener);
        }
        close() {
          Linen.closeModal(this);
        }
      }
    );
  }

  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target.closest) return;

    var size = target.closest('#LinenQuickAdd [data-qa-variant]');
    if (size) {
      e.preventDefault();
      if (size.getAttribute('aria-disabled') === 'true' || size.classList.contains('is-loading')) return;
      var sheet = document.getElementById('LinenQuickAdd');
      var error = sheet.querySelector('[data-qa-error]');
      error.hidden = true;
      size.classList.add('is-loading');
      Linen.closeModal(sheet);
      cart
        .add([{ id: Number(size.getAttribute('data-qa-variant')), quantity: 1 }])
        .catch(function (err) {
          error.textContent = err.message;
          error.hidden = false;
          Linen.openModal(sheet);
        })
        .then(function () {
          size.classList.remove('is-loading');
        });
      return;
    }

    var addVariant = target.closest('[data-linen-add-variant]');
    if (addVariant) {
      e.preventDefault();
      if (addVariant.classList.contains('is-loading')) return;
      addVariant.classList.add('is-loading');
      cart
        .add([{ id: Number(addVariant.getAttribute('data-linen-add-variant')), quantity: 1 }])
        .catch(function (err) {
          toast(err.message);
        })
        .then(function () {
          addVariant.classList.remove('is-loading');
        });
      return;
    }

    var quick = target.closest('[data-linen-quick-add]');
    if (quick) {
      e.preventDefault();
      if (!quick.classList.contains('is-loading')) cart.quickAdd(quick.getAttribute('data-linen-quick-add'), quick);
      return;
    }

    var openBag = target.closest('[data-linen-open-bag]');
    if (openBag) {
      e.preventDefault();
      cart.openBag(openBag);
      return;
    }

    var line = target.closest('[data-linen-line-change]');
    if (line) {
      e.preventDefault();
      var content = bagContent();
      if (content) content.classList.add('is-busy');
      cart
        .change(line.getAttribute('data-key'), parseInt(line.getAttribute('data-quantity'), 10) || 0)
        .catch(function (err) {
          toast(err.message);
        })
        .then(function () {
          var current = bagContent();
          if (current) current.classList.remove('is-busy');
        });
    }
  });

  // Prefetch: the size sheet opens instantly because the product is fetched on touch/hover/focus.
  function warm(e) {
    var el = e.target.closest && e.target.closest('[data-linen-quick-add]');
    if (!el || el.__warmed) return;
    el.__warmed = true;
    getProduct(el.getAttribute('data-linen-quick-add'))
      .then(function (product) {
        if (product.featured_image) new Image().src = product.featured_image + (product.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=208';
      })
      .catch(function () {});
  }
  ['pointerover', 'touchstart', 'focusin'].forEach(function (type) {
    document.addEventListener(type, warm, { passive: true });
  });

  // Back/forward cache can show a stale bag.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) cart.refresh().catch(function () {});
  });
})();

/* Ribbon blast when the offer bar reaches the end (only on the add that unlocks it). */
(function () {
  var prev = null;
  function state() {
    var c = document.querySelector('[data-linen-bag-content]');
    if (!c || c.getAttribute('data-offer-on') !== 'true') return null;
    return { n: parseInt(c.getAttribute('data-offer-count'), 10) || 0, min: parseInt(c.getAttribute('data-offer-min'), 10) || 2 };
  }
  function blast() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var vw = innerWidth, vh = innerHeight, dpr = Math.min(devicePixelRatio || 1, 2);
    var canvas = document.createElement('canvas');
    canvas.setAttribute('aria-hidden', 'true');
    canvas.style.cssText = 'position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:2147483000;';
    canvas.width = vw * dpr;
    canvas.height = vh * dpr;
    document.body.appendChild(canvas);
    var ctx = canvas.getContext('2d');
    ctx.scale(dpr, dpr);
    var colors = ['#000000', '#333333', '#C8A96A', '#777777', '#E4D3A6'];
    var parts = [];
    for (var i = 0; i < 110; i++) {
      parts.push({
        x: Math.random() * vw, y: -20 - Math.random() * vh * 0.35,
        vx: (Math.random() - 0.5) * 3, vy: 4 + Math.random() * 5,
        w: 5 + Math.random() * 5, h: 12 + Math.random() * 12,
        rot: Math.random() * Math.PI, vr: (Math.random() - 0.5) * 0.4,
        color: colors[i % colors.length]
      });
    }
    var DURATION = 2800, start = performance.now();
    (function frame(now) {
      var t = now - start;
      ctx.clearRect(0, 0, vw, vh);
      var fade = t < DURATION * 0.7 ? 1 : Math.max(0, 1 - (t - DURATION * 0.7) / (DURATION * 0.3));
      parts.forEach(function (p) {
        p.vy += 0.14; p.vx *= 0.99; p.x += p.vx; p.y += p.vy; p.rot += p.vr;
        ctx.save();
        ctx.globalAlpha = fade;
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h * Math.abs(Math.cos(p.rot)));
        ctx.restore();
      });
      if (t < DURATION) requestAnimationFrame(frame); else canvas.remove();
    })(start);
  }
  function check() {
    var s = state();
    if (!s) { prev = null; return; }
    if (prev !== null && prev < s.min && s.n >= s.min) setTimeout(blast, 550);
    prev = s.n;
  }
  document.addEventListener('DOMContentLoaded', check);
  document.addEventListener('linen:cart:updated', check);
})();
